<template>
	<div :key="keyValue" class="priority-tree-read-only-box" style="page-break-inside: avoid">
		<egranty-section-divider
			text="Zakres oferty"
			icon="place"
			aria-label="label for icon"
			:show-print-info="showPrintInfo"
		></egranty-section-divider>
		<v-card style="padding: 10px 0 10px 0">
			<v-flex xs12 md12 ml-4 mr-3>
				<display-text-component
					class="modular"
					flex="full-width"
					label="Główny kraj"
					:value="mainCountryName"/>
			</v-flex>
			<ul
				v-for="(optionsList, indexList) in priorityOptions"
				v-bind:key="indexList"
			>
				<li class="ml-3 mr-3 mt-3" v-if="optionsList !== undefined">
					<v-flex xs12 md12>
						<display-text-component
							class="modular"
							flex="full-width"
							label="Priorytet"
							:value="optionsList.name"/>
					</v-flex>
					<v-flex xs12 md12>
						<display-text-component
							class="modular"
							label="Cele ogólne / rezultaty, których dotyczy oferta"
							:key="keyValue"
							flex="full-width"
							v-if="data.selected[indexList] !== undefined"
							:value="getSelectedAsText(optionsList, data.selected[indexList])"/>
					</v-flex>
				</li>
			</ul>
			<v-flex xs12 md12 class="ml-3 mr-3 mt-4">
				<display-text-component
					class="modular"
					label="Dodatkowe kraje"
					v-if="data.mainCountryId && extraCountries.length > 0"
					:value="extraCountries.map(item => item.name).join(', ')"/>
			</v-flex>
		</v-card>
	</div>
</template>

<script>
	import {Task} from "../../../../../api/generated/Task";
	import {TaskAccreditationCountry} from "../../../../../api/generated/TaskAccreditationCountry";
	import EgrantySectionDivider from "../../../../../genericComponents/EgrantySectionDivider";
	import DisplayTextComponent from "../DisplayTextComponent";

	export default {
		name: "PriorityTreeReadOnlyView",
		components: {DisplayTextComponent, EgrantySectionDivider},

		methods: {

			getSelectedAsText(optionsList, selected) {
				const selectedOptions = optionsList.options.filter(opt => selected.areas.includes(opt.id)).map(opt => opt.name);
				if (optionsList.options.length !== 0 && selectedOptions.length !== 0) {
					return selectedOptions.join(', ');
				}
				return '-';
			},

			loadAreas(priority) {
				Task.getAreas(this, priority.id, response => {
						this.$set(priority, "areas", response);
						for (let e = 0; e < response.length; e++) {
							let area = response[e];
							this.$set(area, "type", "area");
							this.$set(area, "uniqueName", area.id + area.type);
						}
					},
				);
			},

			loadPriorities (task, country) {
				Task.getPriorities(this,
          country.id,
					(response) => {

						if (task.children === undefined) {
							this.$set(task, "children", []);
						}
						task.children = task.children.concat(response);
						for (let w = 0; w < response.length; w++) {
							let priority = response[w];
							this.$set(priority, "taskName", task.name);
							this.$set(priority, "countryName", country.name);
							this.$set(priority, "type", "priority");
							this.$set(priority, "uniqueName", priority.id + priority.type);
							this.loadAreas(priority);
						}
						this.left--;
						if (this.left === 0) {
							this.keyValue++;
							this.updatePriorityOptions();
						}
					});
			},

			loadCountries (task, requiredCountry) {
				Task.getTaskAccreditationCountries(this, task.id, (response) => {
					response = response.filter(country => country.name === requiredCountry);
					this.left += response.length;
					for (let q = 0; q < response.length; q++) {
						let country = response[q];

						this.$set(country, "type", "country");
						this.$set(country, "taskName", task.name);
						this.$set(country, "uniqueName", country.id + country.type);
						this.loadPriorities(task, country);
					}
					this.left--;
					if (this.left === 0) {
						this.keyValue++;
						this.updatePriorityOptions();
					}
				});
			},

			loadTasks (requiredCountry, loadForTree) {
				if (this.contestId === undefined || this.data.mainCountryId === null) {
					return;
				}

				this.left++;
				Task.getCountryTasks(this, this.contestId, this.data.mainCountryId, (response) => {

					this.left += response.length;
					for (let i = 0; i < response.length; i++) {
						let task = response[i];
						this.$set(task, "type", "task");
						this.$set(task, "uniqueName", task.id + task.type);
						this.loadCountries(task, requiredCountry);
					}

					this.tasksForPriorities = response;
					if (loadForTree === true) {
						this.tasks = response.sort(function(a, b) {
              return a.orderId - b.orderId;
            });
					}

					this.left--;
					if (this.left === 0) {
						this.keyValue++;
						this.updatePriorityOptions();
					}

				});
			},

			updatePriorityOptions () {
				this.priorityOptions = [];
				this.priorityOptions.length = this.selected.length;
				for (let i = 0; i < this.tasksForPriorities.length; i++) {
					if (this.tasksForPriorities[i].children === undefined) {
						continue;
					}
					for (let q = 0; q < this.tasksForPriorities[i].children.length; q++) {
						let val = this.tasksForPriorities[i].children[q];
						if (this.selected.find(x => x.id === val.id)) {
							let index = this.selected.findIndex(x => x.id === val.id);
							Task.getAreas(this, val.id, response => {
									this.$set(this.priorityOptions, index, {
										name: val.name,
										id: val.id,
										options: response,
									});
									this.keyValue++;
								});
						}
					}
				}
			},

			refresh () {
				if (this.contestId === undefined) {
					return;
				}

				TaskAccreditationCountry.getAvailableCountries(
					this,
					this.contestId,
					response => {
						this.countries = response;
						this.setMainCountryName();
						this.loadTasks(this.mainCountryName, false);
					},
				);


			},

			setMainCountryName () {
				if (this.data.mainCountryId !== null) {
					let country = this.countries.find(x => x.id === this.data.mainCountryId);
					this.mainCountryName = country !== undefined ? country.name : undefined;
					this.extraCountries = this.countries.filter(x => this.value.extraCountries.includes(x.id));
				}
			},
		},

		watch: {
			value: {
				immediate: true,
				handler (val) {
					this.active = val.selected;
					this.data = val;
					this.selected = val.selected;
					this.setMainCountryName();
					this.loadTasks(this.mainCountryName, false);
					this.dataFromServerLoaded = true;
				},
			},

			tree: {
				handler (val) {
					this.data.selected = this.data.selected.filter(x => val.find(y => y.type === 'priority' && y.id === x.id));
					this.priorityOptions = [];
					for (let i = 0; i < val.length; i++) {
						if (val[i].type !== "priority") {
							continue;
						}
						if (!this.data.selected.find(x => x.id === val[i].id)) {
							this.data.selected.push({id: val[i].id, areas: []});
						}
						this.priorityOptions.push({name: val[i].name, id: val[i].id, options: val[i].areas});

					}
					//this.updatePriorityOptions();
					this.$emit("input", this.data);
				},
			},
		},


		data () {
			return {
				error: "",
				dataFromServerLoaded: false,
				tree: [],
				activeTree: [],
				tasks: [],
				tasksForPriorities: [],
				selected: [],
				open: [],
				keyValue: 0,
				active: [],
				left: 0,
				countries: [],
				extraCountries: [],
				data: {
					mainCountryId: null,
					selected: [],
					extraCountries: [],
				},
				priorityOptions: [],
				mainCountryName: "",
			};
		},
		mounted () {
			this.refresh();
		},

		props: {
			value: {
				type: Object,

			},
			contestId: null,
			showPrintInfo: {
				type: Boolean, default: false
			}
		},
	};

</script>

<style scoped>
	@media print {
		.priority-tree-read-only-box {
			border: 1px solid grey;
		}

		.v-card {
			border: none;
		}
	}
</style>
